module.exports = __webpack_public_path__ + "static/img/Dempsey.ffbefd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dempsey.jpg
// module id = sn/Q
// module chunks = 0